export default __webpack_public_path__ + "static/media/010-teddy bear.62335a4b.svg";